import { IslandType } from '@rta/rta-blueprint-library';
import type { Island, Kitchen } from '@rta/rta-blueprint-library';

import { getIslandSuffix } from './get-island-suffix';

export type GetIslandPageTitleParams = {
	island: Island;
	kitchen: Kitchen;
	pageLabel: string;
	islandDescriptionCache?: string;
};

export const getIslandPageTitle = (params: GetIslandPageTitleParams): string => {
	const { island, kitchen, pageLabel, islandDescriptionCache } = params;
	const { islands } = kitchen.design;

	if (islands.children.length === 1) {
		return pageLabel;
	}

	const description = islandDescriptionCache ?? island.description;
	const rawName = description.split(' | ')[0].toUpperCase();
	// Stand islands (Asado/Corner/Smoker/etc.) omit the leading size prefix on page titles; grill/bar keep it.
	const islandName = island.type === IslandType.Grill || island.type === IslandType.Bar
		? rawName
		: rawName.replace(/^\d+(\.\d+)?FT\s+/, '');
	const suffix = getIslandSuffix({ island, kitchen, islandDescriptionCache });

	return suffix
		? `${suffix} | ${islandName} | ${pageLabel}`
		: `${islandName} | ${pageLabel}`;
};
